import Api from './Api';

// URL
const URLS = {
    getProducts: 'get_listing_products',
    getProductsWithFilters: 'get_listing_products_by_filter'
};

const fetchPaginatedProducts = async body => {
    try {
        const ids = body.ids;
        const res = await Api.post(URLS.getProducts, { ids });
        return res?.data;
    } catch (err) {
        console.log(err);
    }
};

const fetchInitialProducts = async body => {
    try {
        const res = await Api.post(URLS.getProductsWithFilters, body);
        return res?.data;
    } catch (err) {
        console.log(err);
    }
};

export default {
    fetchPaginatedProducts,
    fetchInitialProducts
};
